module.exports = __webpack_public_path__ + "img/aiqicha_logo.ed591bce.png";